/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ls from "local-storage";
import { useHistory } from "react-router-dom";
import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { db, storage } from "../Firebase/firebase.js";

const useStyles = makeStyles(styles);
const tablestyle = {
  backgroundColor: "#171942",
  color: "white",
};
export default function Shop() {
  let history = useHistory();
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  const [image, setImage] = React.useState("");
  const imageRef = React.useRef(null);
  const [product_type, setType] = React.useState("");
  const [rows, setRow] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  var [ProductType, setProductTypes] = React.useState([]);
  var [productField, setProductField] = React.useState("");
  const nameRef = React.useRef("");
  const priceRef = React.useRef("");
  const descriptionRef = React.useRef("");
  const deliveryRef = React.useRef("");
  const quantityRef = React.useRef("");
  const viewimageRef = React.useRef(null);
  const [updateimgurl, setupdateimageurl] = React.useState("");
  const [viewimage, setviewImage] = React.useState("");
  const [openViewDialog, setViewDialog] = React.useState(false);

  const [viewname, setviewname] = React.useState("");
  const [viewprice, setviewprice] = React.useState("");
  const [viewdeliverycharges, setviewdeliverycharges] = React.useState("");
  const [viewquantity, setviewquantity] = React.useState("");
  const [viewdescription, setviewdescription] = React.useState("");
  const [viewtype, setviewtype] = React.useState("");
  const updatenameRef = React.useRef("");
  const updatepriceRef = React.useRef("");
  const updatedeliverychargesRef = React.useRef("");
  const updatequantityRef = React.useRef("");
  const updatedescriptionRef = React.useRef("");
  const updatetypeRef = React.useRef("");
  const [viewflag, setviewflag] = React.useState(false);
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const [docid, setDocid] = React.useState("");
  const [img, clearimg] = React.useState(true);

  function useDisplayImage() {
    const [result, setResult] = React.useState("");

    function uploader(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result, uploader };
  }

  const { result, uploader } = useDisplayImage();

  const handleImageChange = (event) => {
    clearimg(false);
    setImage(event.target.files[0]);
    uploader(event);
  };

  function useDisplayImageforView() {
    const [result2, setResult2] = React.useState();

    function uploader2(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult2(e.target.result);
        setupdateimageurl(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result2, uploader2 };
  }

  const { result2, uploader2 } = useDisplayImageforView();

  const handleViewImageChange = (event) => {
    setviewImage(event.target.files[0]);

    uploader2(event);
  };

  const handleTypeChange = (event) => {
    setType(event.target.value);
    let newArray = [];
    db.collection("products")
      .where("type", "==", event.target.value)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  const handleClickOpen = () => {
    clearimg(true);
    setQuantity(1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };
  const classes = useStyles();

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const CheckProductType = (e) => {
    let flag = false;
    setProductField(e.target.value);
    for (var i = 0; i < ProductType.length; i++) {
      if (e.target.value === ProductType[i]) {
        flag = true;
      }
    }
    if (flag === false) {
      ProductType.push(e.target.value);
      setProductTypes(ProductType);
      productField = e.target.value;
    }
  };

  var [quantity, setQuantity] = React.useState(1);

  const IncrementQuantity = () => {
    if (quantity < 20000) {
      setQuantity(++quantity);
    }
  };

  const DecrementQuantity = () => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
    }
  };

  const openconfirmationbox = () => {
    setopendeletebox(true);
  };
  const closeconfirmationbox = () => {
    setopendeletebox(false);
  };
  const deleteDialog = (row) => {
    setDocid(row.productId);
    setopendeletebox(true);
  };
  const handleViewClose = () => {
    if (setviewflag === true) {
      setViewDialog(false);
    } else {
      updateProduct();
    }
  };

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      getProductTypes();
      getProducts();
    }
  }, []);
  const viewProduct = (row) => {
    setviewflag(true);
    setviewname(row.name);
    setviewprice(row.price);
    setviewdescription(row.description);
    setviewquantity(row.quantity);
    setviewtype(row.type);
    setviewdeliverycharges(row.deliveryCharges);
    setviewImage(row.image);
    setupdateimageurl(row.image);
    setViewDialog(true);
  };
  const updateProductDialog = (row) => {
    setQuantity(row.quantity);
    setviewflag(false);
    setDocid(row.productId);
    setviewname(row.name);
    setviewprice(row.price);
    setviewdescription(row.description);
    setviewquantity(row.quantity);
    setviewtype(row.type);
    setviewdeliverycharges(row.deliveryCharges);
    setviewImage(row.image);
    setupdateimageurl(row.image);
    setViewDialog(true);
  };

  var getProductTypes = () => {
    let newArray = [];
    db.collection("products")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data().type);
        });
      
        function onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        }
        setProductTypes(newArray.filter(onlyUnique));
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  var getProducts = () => {
    let newArray = [];
    db.collection("products")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  const DeleteProduct = () => {
    db.collection("products")
      .doc(docid)
      .delete()
      .then(() => {
        setopendeletebox(false);
        getProducts();
        getProductTypes();
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  const addProducts = () => {
    const ref = storage.ref(`/products/${image.name}`);
    const uploadTask = ref.put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("products")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("products")
              .add({
                name: nameRef.current.value,
                price: priceRef.current.value,
                description: descriptionRef.current.value,
                type: productField.toLowerCase(),
                image: url,
                quantity: quantityRef.current.value,
                deliveryCharges: deliveryRef.current.value,
              })
              .then((doc) => {
                db.collection("products").doc(doc.id).set(
                  {
                    productId: doc.id,
                  },
                  { merge: true }
                );
                setOpen(false);
                setTimeout(() => {
                  getProducts();
                  getProductTypes();
                }, 2000);
              })
              .catch((err) => {
                console.log(err);
              });
          });
      }
    );
  };

  const updateProduct = () => {
    if (typeof viewimage === "object") {
      const ref = storage.ref(`/products/${viewimage.name}`);
      const uploadTask = ref.put(viewimage);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("products")
            .child(viewimage.name)
            .getDownloadURL()
            .then((url) => {
              db.collection("products")
                .doc(docid)
                .set(
                  {
                    name: updatenameRef.current.value,
                    price: updatepriceRef.current.value,
                    description: updatedescriptionRef.current.value,
                    type: (updatetypeRef.current.value).toLowerCase(),
                    image: url,
                    quantity: updatequantityRef.current.value,
                    deliveryCharges: updatedeliverychargesRef.current.value,
                  },
                  { merge: true }
                )
                .then(() => {
                  setViewDialog(false);
                  setTimeout(() => {
                    getProducts();
                    getProductTypes();
                  }, 2000);
                })
                .catch((err) => {
                  console.log(err);
                });
            });
        }
      );
    } else {
      db.collection("products")
        .doc(docid)
        .set(
          {
            name: updatenameRef.current.value,
            price: updatepriceRef.current.value,
            description: updatedescriptionRef.current.value,
            type: updatetypeRef.current.value,
            image: viewimage,
            quantity: updatequantityRef.current.value,
            deliveryCharges: updatedeliverychargesRef.current.value,
          },
          { merge: true }
        )
        .then(() => {
          setViewDialog(false);
          setTimeout(() => {
            getProducts();
            getProductTypes();
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "500px" : "50px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: 262 }}
            >
              <InputLabel id="type_label">Product Type</InputLabel>
              <Select
                labelId="type_id"
                id="product_type"
                value={product_type}
                onChange={handleTypeChange}
                label="Product Type"
              >
                {ProductType.map((element, index) => {
                  return (
                    <MenuItem key={index} value={element}>
                      {element}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        </GridItem>
      </GridContainer>
      <br></br>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflow: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tablestyle}>ID</TableCell>
                  <TableCell style={tablestyle} align="left">
                    Product Name
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Quantity
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Product Cost
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Shipping Cost
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.productId}>
                    <TableCell
                      component="th"
                      scope="row"
                      onClick={() => viewProduct(row)}
                      style={{ color: "skyblue" }}
                    >
                      {row.productId}
                    </TableCell>

                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.quantity}</TableCell>
                    <TableCell align="left">{row.price}</TableCell>
                    <TableCell align="left">{row.deliveryCharges}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => deleteDialog(row)}>
                          <DeleteForeverIcon
                            style={{ color: "red", width: "18" }}
                          />
                        </IconButton>
                        <IconButton onClick={() => updateProductDialog(row)}>
                          <EditIcon style={{ color: "green", width: "18" }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
          <Button
            onClick={handleClickOpen}
            style={{ backgroundColor: "#171942" }}
          >
            Add Product
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="Product-title"
            aria-describedby="Product-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="product-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Add Product</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 800, width: 600 }}>
              <div className="product-form">
                <div
                  className="imageContainer"
                  style={{
                    width: "38%",
                    height: "150px",
                    backgroundColor: "transparent",
                    marginLeft: mobileratio ? 0 : "auto",
                    marginRight: "auto",
                    marginBottom: "auto",
                    marginTop: "auto",
                  }}
                >
                  <img
                    src={img ? "" : result}
                    ref={imageRef}
                    alt=""
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundSize: "cover",
                    }}
                  ></img>
                </div>
                <br></br>
                <div>
                  <input
                    onChange={handleImageChange}
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <label
                    style={{
                      marginLeft: mobileratio ? 0 : 200,
                      marginTop: -20,
                    }}
                    htmlFor="icon-button-file"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<PhotoCamera />}
                    >
                      Upload
                    </Button>
                  </label>
                  <br></br>
                  <TextField
                    inputRef={nameRef}
                    required
                    label="Name"
                    variant="outlined"
                    style={{ width: mobileratio ? 250 : 535 }}
                  />
                  <br></br>
                  {mobileratio ? <br></br> : <br></br>}
                  <TextField
                    inputRef={deliveryRef}
                    required
                    label="Delivery Charges"
                    variant="outlined"
                    style={{ marginRight: "35px", width: "250px" }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <TextField
                    inputRef={priceRef}
                    required
                    label="Price"
                    variant="outlined"
                    style={{ width: 250 }}
                  />
                </div>
                <div>
                  {mobileratio ? <br></br> : <br></br>}
                  <TextField
                    required
                    label="Product Type"
                    variant="outlined"
                    style={{ width: "250px" }}
                    onBlur={CheckProductType}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <IconButton
                    style={{ marginRight: "5px",marginLeft: mobileratio ? "0px":"20px" }}
                    onClick={IncrementQuantity}
                  >
                    <AddIcon
                      style={{
                        color: "white",
                        width: "30",
                        height: "30",
                        backgroundColor: "#171942",
                        borderRadius: 30,
                      }}
                    />
                  </IconButton>
                  <TextField
                    inputRef={quantityRef}
                    value={quantity}
                    required
                    label="Quantity"
                    variant="outlined"
                    style={{ width: "150px" }}
                  />
                  <IconButton
                    onClick={DecrementQuantity}
                    style={{ paddingLeft: "13px" }}
                  >
                    <RemoveIcon
                      style={{
                        color: "white",
                        width: "30",
                        height: "30",
                        backgroundColor: "#171942",
                        borderRadius: 30,
                      }}
                    />
                  </IconButton>
                </div>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  inputRef={descriptionRef}
                  required
                  label="Description"
                  multiline
                  rowsMax={5}
                  variant="outlined"
                  style={{ width: mobileratio ? 250 : 535 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 555,
                  backgroundColor: "#171942",
                }}
                onClick={addProducts}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="Product-title"
            aria-describedby="Product-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="product-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}></h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 800, width: 600 }}>
              <div className="product-form">
                <div
                  className="imageContainer"
                  style={{
                    width: "38%",
                    height: "150px",
                    backgroundColor: "transparent",
                    marginLeft: mobileratio ? 0 : "auto",
                    marginRight: "auto",
                    marginBottom: "auto",
                    marginTop: "auto",
                  }}
                >
                  <img
                    src={updateimgurl}
                    ref={viewimageRef}
                    alt=""
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundSize: "cover",
                    }}
                  ></img>
                </div>
                <br></br>
                <div>
                  <input
                    onChange={handleViewImageChange}
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <label
                    style={{
                      marginLeft: mobileratio ? 0 : 200,
                      marginTop: -20,
                    }}
                    htmlFor="icon-button-file"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<PhotoCamera />}
                      style={{ display: viewflag ? "none" : "inline-block" }}
                    >
                      Upload
                    </Button>
                  </label>
                  <br></br>
                  <TextField
                    inputRef={updatenameRef}
                    value={viewflag ? viewname : null}
                    defaultValue={viewflag ? null : viewname}
                    required
                    label="Name"
                    variant="outlined"
                    style={{ width: mobileratio ? 250 : 535 }}
                  />
                  <br></br>
                  {mobileratio ? <br></br> : <br></br>}
                  <TextField
                    inputRef={updatedeliverychargesRef}
                    value={viewflag ? viewdeliverycharges : null}
                    defaultValue={viewflag ? null : viewdeliverycharges}
                    required
                    label="Delivery Charges"
                    variant="outlined"
                    style={{ marginRight: "35px", width: "250px"  }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <TextField
                    inputRef={updatepriceRef}
                    value={viewflag ? viewprice : null}
                    defaultValue={viewflag ? null : viewprice}
                    required
                    label="Price"
                    variant="outlined"
                    style={{ width: "250px" }}
                  />
                </div>
                <div>
                  {mobileratio ? <br></br> : <br></br>}
                  <TextField
                    inputRef={updatetypeRef}
                    value={viewflag ? viewtype : null}
                    defaultValue={viewflag ? null : viewtype}
                    required
                    label="Product Type"
                    variant="outlined"
                    style={{ width: "250px" }}
                    onBlur={CheckProductType}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <IconButton
                    style={{
                      marginLeft:mobileratio ? "0px":"20px",
                      marginRight:"5px",
                      display: viewflag ? "none" : "inline-block",
                    }}
                    onClick={IncrementQuantity}
                  >
                    <AddIcon
                      style={{
                        color: "white",
                        width: "30px",
                        height: "30px",
                        backgroundColor: "#171942",
                        borderRadius: 30,
                      }}
                    />
                  </IconButton>
                  <TextField
                    inputRef={updatequantityRef}
                    value={viewflag ? viewquantity : quantity}
                    defaultValue={viewflag ? null : viewquantity}
                    required
                    label="Quantity"
                    variant="outlined"
                    style={{
                      width: viewflag ? "250px" : "150px",
                      marginLeft: mobileratio ?0 :viewflag ? "35px" : "0px",
                    }}
                  />
                  <IconButton
                    onClick={DecrementQuantity}
                    style={{
                      paddingLeft: "13px",
                      display: viewflag ? "none" : "inline-block",
                    }}
                  >
                    <RemoveIcon
                      style={{
                        color: "white",
                        width: "30",
                        height: "30",
                        backgroundColor: "#171942",
                        borderRadius: 30,
                      }}
                    />
                  </IconButton>
                </div>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  inputRef={updatedescriptionRef}
                  value={viewflag ? viewdescription : null}
                  defaultValue={viewflag ? null : viewdescription}
                  required
                  label="Description"
                  multiline
                  rowsMax={5}
                  variant="outlined"
                  style={{ width: mobileratio ? 250 : 535 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleViewClose}
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 555,
                  backgroundColor: "#171942",
                }}
              >
                {viewflag ? "close" : "Update"}
              </Button>
            </DialogActions>
          </Dialog>
          {/* confirmation box */}
          <Dialog
            open={opendeletebox}
            onClose={closeconfirmationbox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Are you sure you want to delete?
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions>
              <Button onClick={DeleteProduct} color="primary">
                Yes
              </Button>
              <Button onClick={closeconfirmationbox} color="primary">
                No
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    </>
  );
}
